<style scoped>
    p h4 h5{
        font-family: GillSans, Calibri, Trebuchet, sans-serif !important;
    }
</style>
<template>
    <div class="row">
        <div class="section">
            <div class="container">
                <div class="brown-text col s12 m4 l4">
                    <h4>LOCALIZAÇÃO</h4>
                    <p class="">
                        O Resplendor Center Hotel está localizado na Avenida Olegário Maciel, 364 B
                        no Centro de Resplendor em Minas Gerais.
                    </p>
                    <h5>Como Chegar</h5>
                    <p>
                        O Resplendor Center Hotel está aproximadamente 3,8 Km da ponte de Resplendor na BR259,
                        e a 1 Km da Rodoviária.
                    </p>
                </div>
                <div class="col s12 m8 l8">
                    <iframe class="hide-on-med-and-up z-depth-4" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3764.98176657906!2d-41.25751408509507!3d-19.32659748694456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xb72c9762d8f7bf%3A0x545e6b542bc56e9e!2sResplendor+Center+Hotel!5e0!3m2!1spt-BR!2sbr!4v1489704108722" width="300" height="300" frameborder="0" style="border:0" allowfullscreen></iframe>
                    <iframe class="right hide-on-small-only z-depth-4" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3764.98176657906!2d-41.25751408509507!3d-19.32659748694456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xb72c9762d8f7bf%3A0x545e6b542bc56e9e!2sResplendor+Center+Hotel!5e0!3m2!1spt-BR!2sbr!4v1489704108722" width="400" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    export default {
        mounted(){
        }
    };
</script>


// WEBPACK FOOTER //
// localizacao.vue?24012187